module.exports = __webpack_public_path__ + "static/img/desktop-bzgl.0b507393.png";